<div class="container">
  <div class="pt-10">
 
    <ion-row class="center-content">
      <ion-col size-sm="12" size-md="6" size-lg="10" size-xs="12">
        <ion-row class="borderbottomForTab">
          <ion-col size-sm="10" size-md="9" size-lg="2" size-xs="10" class="mb-10">
            <div>

              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForDashboard"
                  (selectionChange)="viewDashboardExpenseByYear($event.value)">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </ion-col>


          <ion-col size-sm="10" size-md="9" size-lg="3" size-xs="10" class="mb-10">
            <mat-form-field class="w-100 mat-height40 mat-input-style" style="margin-left: 10px;">
              <mat-date-range-input [rangePicker]="startDatePicker">
                <input matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDateForAllGraph"
                  (dateChange)="processAllGraphDateRange()">
                <input matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDateForAllGraph"
                  (dateChange)="processAllGraphDateRange()">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #startDatePicker></mat-date-range-picker>
            </mat-form-field>

          </ion-col>
       
        <ion-col size-sm="10" size-md="9" size-lg="3" size-xs="10" class="mb-10"
          *ngIf="loggedInUserRole == 'Manager' && !OnlyFinance ">
          <mat-form-field class="w-100 mat-height40 mat-input-style" style="margin-left: 10px;">
            <mat-select placeholder="Select Employee" (selectionChange)="onEmployeeChangeByManager($event.value)"
              [(ngModel)]="employeeID">
              <mat-option *ngFor="let item of getEmployeeList" [value]="item.employeeId">
                {{ item.employeeName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>

          <ion-col size-sm="10" size-md="9" size-lg="4" size-xs="10" class="mb-10" *ngIf="loggedInUserRole == 'Manager' && !OnlyFinance && OnlyManager ">
            <div class="card" (click)="onClickCard('Manager')" style="margin-left: 10px;">
              <div class="d-flex">
                <div>
                  <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>
                </div>
          
                <ion-row>
                  <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
                    <div class="text-center ml-30">
                      <p class="fs-12 font_semibold cp">No. of expense pending from manager</p>
                      <p class="mt-5 fs-12 font_bold text_green cp">{{pendingWithManager}}</p>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </ion-col>

        </ion-row>
      </ion-col>
    </ion-row>
  </div>
 
 year
  <ion-row class="pt-10">
    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6" >
      <div class="card" (click)="onClickCard(1)">
        <div class="d-flex">
          <div>
            <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>
          <ion-row >
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold text-center" >No of expenses raised</p>
                <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">{{totalExpenseRaisedCount}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>

    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
      <div class="card" (click)="onClickCard(2)">
        <div class="d-flex">
          <div>
            <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>
          <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold" >No of expenses paid</p>
                <p class="mt-5 fs-12 font_bold yellow">00</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>
    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
      <div class="card" (click)="onClickCard(3)">
        <div class="d-flex">
          <div>
            <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>

          <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold cp" >No. of expense approved by finance</p>
                <p class="mt-5 fs-12 font_bold text_green cp">{{totalExpenseApprovedByfinance}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>
    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
      <div class="card"  (click)="onClickCard(4)">
        <div class="d-flex">
          <div>
            <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>

          <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold cp">No. of expense pending by finance</p>
                <p class="mt-5 fs-12 font_bold text_green cp">{{totalExpensePendingByfinance}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>

  </ion-row>
  <ion-row class="pt-10">
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Expense Applied Count</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="switchReimbursementTypeGraph('bar')">
                <img *ngIf="isReimbursementTypeIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isReimbursementTypeIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchReimbursementTypeTable()">
                <img *ngIf="!isReimbursementTypeTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isReimbursementTypeTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchReimbursementTypeGraph('line')">
                <img *ngIf="isReimbursementTypeIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isReimbursementTypeIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Expense Applied Count')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <ion-row>
            <div class="d-flex ">
              <mat-form-field class="w-60 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForReimbursement"
                  (selectionChange)="viewReimbursementYear($event.value)">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="w370  mat mat-height40 mat-input-style mr-15" style="margin-left: 10px;">
                <mat-date-range-input [rangePicker]="fromToDateDashboard">
                  <input matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDate"
                    (dateChange)="processFirstGraphDateRange()">
                  <input matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDate"
                    (dateChange)="processFirstGraphDateRange()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="fromToDateDashboard"></mat-datepicker-toggle>
                <mat-date-range-picker #fromToDateDashboard></mat-date-range-picker>
              </mat-form-field>

            </div>
          </ion-row>
        </div>


        <ion-col size-sm="12" size-md="12" size-lg="12" size-xl="12">
          <div [ngClass]="{'dispNone' : !isReimbursementTypeTable}">
            <div class="dashboardGraphTable">
              <table id="table-data">
                <thead>
                  <tr class="custom-size">
                    <th>Reimbursement Type </th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of reimbursementTypeTable">
                    <td>{{data.reimbursementType}}</td>
                    <td>{{data.count}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isReimbursementTypeTable}" id="bar-line-chart"
            style="width: 550px; height: 400px;" class="col-xl-12"></div>
        </ion-col>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Total Expense Amount</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="switchApprovedByFinanceGraph('bar')">
                <img *ngIf="isApprovedByFinanceIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isApprovedByFinanceIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchApprovedByFinanceTable()">
                <img *ngIf="!isApprovedByFinanceTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isApprovedByFinanceTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchApprovedByFinanceGraph('line')">
                <img *ngIf="isApprovedByFinanceIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isApprovedByFinanceIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Total Expense Amount')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>

        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div [ngClass]="{'dispNone' : !isApprovedByFinanceTable}">
            <div class="dashboardGraphTable">
              <table id="table-approvedByFinance-data">
                <thead>
                  <tr class="custom-size">
                    <th>year</th>
                    <th>Total amount paid in reimbursements</th>
                    <th>No. of employees</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of arrApprovedByFinanceTable">
                    <td>{{data.year}}</td>
                    <td>{{data.totalAmount}}</td>
                    <td>{{data.employeeCount}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isApprovedByFinanceTable}" id="bar-line-approvedByFinance-chart"
            style="width: 550px; height: 400px;">
          </div>
        </ion-col>


      </div>
    </ion-col>
  </ion-row>
  <!-- second row for graph -->
  <ion-row class="pt-10">
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Expense Paid VS Applied</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="switchFinanceAmountPaidGraph('bar')">
                <img *ngIf="isFinanceAmountPaidIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isFinanceAmountPaidIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchFinanceAmountPaidTable()">
                <img *ngIf="!isFinanceAmountPaidTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isFinanceAmountPaidTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchFinanceAmountPaidGraph('line')">
                <img *ngIf="isFinanceAmountPaidIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isFinanceAmountPaidIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Expense Paid VS Applied')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <ion-row>
            <div class="d-flex ">
              <mat-form-field class="w-60 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForReimbursement"
                  (selectionChange)="viewReimbursementYear($event.value)">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- First Date Range Picker -->


              <!-- Second Date Range Picker -->
              <mat-form-field class="w370 mat mat-height40 mat-input-style mr-15" style="margin-left: 10px;">
                <mat-date-range-input [rangePicker]="secondDatePicker">
                  <input matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDateForThirdGraph"
                    (dateChange)="processThirdGraphDateRange()">
                  <input matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDateForThirdGraph"
                    (dateChange)="processThirdGraphDateRange()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="secondDatePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #secondDatePicker></mat-date-range-picker>
              </mat-form-field>


            </div>
          </ion-row>
        </div>

 
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div [ngClass]="{'dispNone' : !isFinanceAmountPaidTable}">
            <div class="dashboardGraphTable">
              <table id="table-data-Finance-Employee">
                <thead>
                  <tr class="custom-size">
                    <th>Expense Type </th>
                    <th>Amout paid by finance</th>
                    <th >Amount by employees</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of arrApprovedPaidAmountTable">
                    <td>{{data.reimbursementType}}</td>
                    <td>{{data.totalActualAmount}}</td>
                    <td>{{data.totalAssignedAmount}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isFinanceAmountPaidTable}" id="bar-line-amount-chart"
            style="width: 550px; height: 400px;"></div>
        </ion-col>
      </div>
    </ion-col>

  </ion-row>

</div>